/* Tribe board product page: size helper + small reveals. Sizing rules live in tribe-sizing.js. */
(function () {
  'use strict';
  var HL = { h1: 'Under 4\'6"', h2: '4\'6" to 5\'0"', h3: '5\'0" to 5\'2"', h4: '5\'2" to 5\'4"', h5: '5\'4" to 5\'5"', h6: '5\'5" to 5\'8"', h7: '5\'8" to 5\'10"', h8: '5\'10" to 6\'0"', h9: '6\'0" to 6\'2"', h10: '6\'2" to 6\'4"', h11: '6\'4" and up' };
  function TS() { return window.TribeSizing; }
  function fmt(n) { return TS().fmt(n); }
  function rng(r) { return TS().rng(r); }

  function chartTable() {
    var h = '<table class="tribe-sh__table"><thead><tr><th>Your height</th><th>Standard</th><th>High volume (180 lb+)</th></tr></thead><tbody>';
    Object.keys(HL).forEach(function (k) { h += '<tr><td>' + HL[k] + '</td><td>' + rng(TS().STD[k]) + '</td><td>' + (['h1', 'h2', 'h3', 'h4'].indexOf(k) > -1 ? '' : rng(TS().HV[k])) + '</td></tr>'; });
    return h + '</tbody></table><p class="tribe-sh__note">Dropknee riders, beginners, soft small waves and riding without swimfins can go up to 1\" longer. Advanced riders and hollow or big waves can go up to 1\" shorter. Your chin-to-knee measurement is also a great starting point.</p>';
  }

  function pickSize(root, value) {
    var scope = root.closest('form, .product-detail, .product-info, section') || document;
    var section = root.closest('.shopify-section') || document;
    var done = false;
    section.querySelectorAll('select').forEach(function (sel) {
      if (done) return;
      var opt = Array.prototype.find.call(sel.options, function (o) { return o.value === value || o.textContent.trim() === value; });
      var lbl = (sel.getAttribute('name') || '') + ' ' + (sel.id || '') + ' ' + ((sel.closest('.option-selector, .product-option, fieldset') || {}).textContent || '');
      if (opt && /size|length/i.test(lbl)) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); done = true; }
    });
    if (done) return true;
        section.querySelectorAll('custom-select').forEach(function (cs) {
      if (done) return;
      var wrap = cs.closest('.option-selector, .product-option, fieldset, [data-option]');
      var lbl = wrap ? ((wrap.getAttribute('data-option') || '') + ' ' + wrap.textContent) : '';
      var li = Array.prototype.find.call(cs.querySelectorAll('li[role=option]'), function (o) { return o.getAttribute('data-value') === value; });
      if (li && /size|length/i.test(lbl) && typeof cs.selectOption === 'function') { cs.selectOption(li); done = true; }
    });
    if (done) return true;
    section.querySelectorAll('input[type=radio]').forEach(function (inp) {
      if (done) return;
      var wrap = inp.closest('.option-selector, .product-option, fieldset, [data-option]') || {};
      if (inp.value === value && /size|length/i.test((inp.name || '') + ' ' + (wrap.textContent || ''))) { inp.click(); done = true; }
    });
    return done;
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var tg = root.querySelector('.tribe-sh__toggle'), panel = root.querySelector('.tribe-sh__panel');
    var out = root.querySelector('.tribe-sh__out');
    var sizes = []; try { sizes = JSON.parse(root.querySelector('[data-sizes]').textContent); } catch (e) {}
    root.querySelector('[data-chart]').innerHTML = chartTable();
    tg.addEventListener('click', function () { var o = panel.hidden; panel.hidden = !o; tg.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    function val(sel) { var el = root.querySelector(sel); return el ? el.value : ''; }
    function calc() {
      var h = val('[data-h]'), w = val('[data-w]');
      if (!h || !w) { out.innerHTML = ''; return; }
      var p = TS().plan({ height: h, weight: w, style: val('[data-style]'), level: val('[data-level]'), waves: val('[data-waves]'), fins: val('[data-fins]'), ck: val('[data-ck]') });
      var avail = sizes.filter(function (s) { return s.s != null && s.a; }).map(function (s) { return { size: s.s, v: s.v }; });
      var list = TS().choose(avail, p);
      var hm = '<p class="tribe-sh__res">Your size: <strong>' + rng(p.base) + '</strong>' +
        (p.measure != null ? ' <span>(from your chin-to-knee measurement. The chart says ' + rng(p.chart) + ')</span>' : ' <span>(from the size chart)</span>') + '</p>';
      if (p.mismatch) hm += '<p class="tribe-sh__warn">These don\'t match, double-check your measurement.</p>';
      if (p.lean) hm += '<p class="tribe-sh__note">' + p.lean + '</p>';
      if (p.hv && root.dataset.hvBoard !== '1') hm += '<p class="tribe-sh__warn">At 180 lb and up, a high volume board like the Hunter or Chief will float you better. <a href="/collections/tribe#tribe-selector">Find Your Tribe Board</a></p>';
      if (list.length) {
        var TAG = { mine: 'your size', chart: 'size chart', longer: 'longer, more float', shorter: 'shorter, looser' };
        hm += '<div class="tribe-sh__sizes">';
        list.forEach(function (o) {
          hm += '<button type="button" class="tribe-sh__size' + (o.best ? ' is-best' : '') + '" data-v="' + o.items[0].v.replace(/"/g, '&quot;') + '">' + fmt(o.size) + '<small>' + TAG[o.tag] + '</small></button>';
        });
        hm += '</div><p class="tribe-sh__hint">Tap a size to select it.</p>';
      } else {
        hm += '<p class="tribe-sh__warn">Your size is sold out in this board right now. <a href="/collections/tribe#tribe-selector">See which Tribe boards have it</a> or <a href="/pages/booger-picker">ask Jay</a>.</p>';
      }
      out.innerHTML = hm;
    }
    root.addEventListener('input', function (e) { if (e.target.closest('[data-ck]')) calc(); });
    root.addEventListener('change', function (e) { if (e.target.closest('.tribe-sh__panel select, .tribe-sh__panel input')) calc(); });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.tribe-sh__size'); if (!b) return;
      root.querySelectorAll('.tribe-sh__size').forEach(function (x) { x.classList.toggle('is-picked', x === b); });
      var ok = pickSize(root, b.getAttribute('data-v'));
      var hint = root.querySelector('.tribe-sh__hint');
      if (hint) hint.textContent = ok ? b.textContent.replace(/(\d)"(.*)/, '$1"') + ' selected. Now pick your color.' : 'Select ' + b.getAttribute('data-v') + ' in the Size options above.';
    });
  }

  function reveal() {
    var els = document.querySelectorAll('.tribe-rv');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function boot() { document.querySelectorAll('[data-tribe-sh]').forEach(init); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
